<template>
    <transition name="fade">
        <div class="share-modal">
            <div class="modal-backdrop absolute w-full h-full" @click="closeModal"></div>
            <div class="modal-content flex flex-col relative">
                <InnerLoader v-if="isLoading" class="payment-loading" :z-index="999" />
                <div class="modal-header flex justify-between justify-start p-4">
                    <h3 class="font-size-20 shadow-text-none p-0 m-0">
                        {{ title ? title : translate('playalone_share_quiz_modal') }}
                    </h3>
                    <div v-if="!subTitle" class="leading-none">
                        <i @click="closeModal" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                    </div>
                </div>
                <h5 v-if="subTitle" class="font-size-16 shadow-text-none pt-2 p-0 m-0">{{ subTitle }}</h5>
                <div class="modal-body p-4 pt-0">
                    <template v-if="!isFrontPage">
                        <p class="font-size-16 shadow-text-none">
                            {{ translate('playalone_share_quiz_modal_save_report_description') }}
                        </p>
                        <Selection
                            v-model="reportId"
                            @input="onSelectReport"
                            :indicator="{ color: '#333' }"
                            id="report-select"
                            class="font-size-16 mt-5"
                        >
                            <option value="">-- {{ $t('report_select_report') }} --</option>
                            <option
                                v-for="report in createdReports"
                                :key="report.custom_report_id"
                                :value="report._id.$oid"
                                :disabled="report.disabled"
                            >
                                {{ report.name }}
                                {{
                                    report.limit_player
                                        ? translate('playalone_played_limit', {
                                              userCount: report.played_user_count,
                                              limitPlayer: report.limit_player
                                          })
                                        : ''
                                }}
                            </option>
                        </Selection>

                        <div v-if="isLoggedIn()" class="text-center my-2">
                            <div
                                @click.prevent="onToggleReportSetting"
                                class="inline-block font-size-16 shadow-text-none cursor-pointer"
                            >
                                <i
                                    :class="{
                                        fas: true,
                                        'fa-plus-circle': !isSelectReport,
                                        'fa-minus-circle': isSelectReport
                                    }"
                                ></i>
                                {{ translate('playalone_create_report_modal') }}
                            </div>
                        </div>

                        <template v-if="isSelectReport">
                            <div class="create-report-box flex">
                                <XInput
                                    @input="e => (reportName = e.target.value.trim())"
                                    :placeholder="$t('report_report_name')"
                                    class="url-input p-4"
                                />
                                <XButton
                                    @click="onCreateReport"
                                    :disabled="!readyToCopy"
                                    class="btn-create-report"
                                    font-weight="400"
                                >
                                    <template>{{ translate('playalone_create_report_url') }}</template>
                                </XButton>
                            </div>
                        </template>

                        <div v-if="reportId">
                            <p class="font-size-16 text-center shadow-text-none mt-4">
                                {{ translate('playalone_share_quiz_modal_header_identify') }}
                            </p>
                            <div class="identify-box flex justify-center items-center mt-2">
                                <XCheckbox
                                    v-if="!isFeideUser"
                                    :checked="true"
                                    :disabled="isSharedReport"
                                    theme="dark"
                                    type="checkbox"
                                    name="identify"
                                    size="md"
                                    class="pointer-events-none"
                                >
                                    <span class="font-size-16 shadow-text-none">
                                        {{ translate('playalone_share_quiz_modal_identify_name') }}
                                    </span>
                                </XCheckbox>
                                <XCheckbox
                                    v-if="!isFeideUser && !isSchoolRoles"
                                    @input="handleToggleMail"
                                    :checked="isSpecifyEmail"
                                    :disabled="isSharedReport"
                                    theme="dark"
                                    type="checkbox"
                                    name="identify"
                                    size="md"
                                >
                                    <span class="font-size-16 shadow-text-none">
                                        {{ translate('playalone_share_quiz_modal_identify_email') }}
                                    </span>
                                </XCheckbox>
                                <XCheckbox
                                    v-if="isFeideUser && !isUserInOsloSchool"
                                    @input="handleToggleForceLoginFeide"
                                    :checked="isForceLoginFeide"
                                    :disabled="isSharedReport"
                                    theme="dark"
                                    type="checkbox"
                                    name="feide-identify"
                                    size="md"
                                >
                                    <span class="font-size-16 shadow-text-none">
                                        {{ translate('playalone_share_quiz_modal_force_login_with_feide') }}
                                    </span>
                                </XCheckbox>
                                <div v-if="isSchoolRoles && !isUserInOsloSchool" class="flex">
                                    <span class="mr-2 text-grey">|</span>
                                    <XCheckbox
                                        @input="handleToggleUseWhiteList"
                                        :checked="useWhiteList"
                                        :disabled="isSharedReport"
                                        theme="dark"
                                        type="checkbox"
                                        name="feide-identify"
                                        size="md"
                                    >
                                        <span class="font-size-16 shadow-text-none">
                                            {{ $t('my_quiz_tab_whitelist') }}
                                        </span>
                                    </XCheckbox>
                                </div>
                                <div v-if="isUserInOsloSchool" class="text-sm text-red">
                                    {{ $t('playalone_share_quiz_modal_player_must_login_with_feide') }}
                                </div>
                            </div>

                            <div v-if="isSchoolRoles && useWhiteList && !isSharedReport" class="my-2">
                                <label class="font-size-16 font-bold mb-1 block">{{
                                    $t('my_quiz_tab_whitelist')
                                }}</label>
                                <select
                                    v-model="whitelistId"
                                    @change="updateUseWhitelist"
                                    class="select-input font-size-16"
                                >
                                    <option value="">-- {{ $t('whitelist_modal_header_select_whitelist') }} --</option>
                                    <option
                                        v-for="whitelist in whitelists"
                                        :key="whitelist._id.$oid"
                                        :value="whitelist._id.$oid"
                                    >
                                        {{ whitelist.name }}
                                    </option>
                                </select>
                                <small class="text-sm block text-center mt-1 text-dark-grey">{{
                                    $t('playalone_share_quiz_modal_only_whitelist_player_can_play')
                                }}</small>
                            </div>

                            <Qrcanvas :options="qrCodeOptions" class="qrcode block h-full mx-auto my-4 show"></Qrcanvas>
                            <XInput
                                @focus.native="onFocus"
                                :value="urlShare"
                                :readonly="true"
                                class="url-input w-full p-4"
                            />
                            <div v-if="isLocked" class="text-center">
                                <span class="text-sm text-red">
                                    <i class="fas fa-lock"></i>
                                    {{ $t('playalone_share_report_is_locked') }}</span
                                >
                            </div>
                            <div class="share-quiz-box flex justify-between mt-3">
                                <ShareButton
                                    :disabled="!reportId"
                                    :url="urlShare"
                                    :title="quizTitle"
                                    share-type="copy"
                                    class="x-button font-opensans w-full shadow-text-none system-button-color system-button-text-color"
                                    font-weight="400"
                                    tag="button"
                                >
                                    <i class="fas fa-paste"></i>
                                    {{ translate('playalone_share_quiz_modal_button_copy') }}
                                </ShareButton>
                                <ShareButton
                                    v-if="isCanShare"
                                    :disabled="!reportId"
                                    :url="urlShare"
                                    :title="quizTitle"
                                    share-type="share"
                                    class="x-button font-opensans w-full shadow-text-none system-button-color system-button-text-color"
                                    font-weight="400"
                                    tag="button"
                                >
                                    <i class="fas fa-share-alt"></i>
                                    {{ translate('playalone_share_quiz_modal_button_share') }}
                                </ShareButton>
                            </div>
                            <p
                                v-if="createdReports.find(e => e._id.$oid === reportId)"
                                v-html="
                                    translate('playalone_share_quiz_modal_save_report_description2', {
                                        report: createdReports.find(e => e._id.$oid === reportId).name
                                    })
                                "
                                class="mt-4 font-size-16 text-center shadow-text-none"
                            ></p>
                        </div>

                        <div :class="[{ 'text-center footer-box': true, 'mt-4': reportId, 'mt-16': !reportId }]">
                            <p v-if="isLoggedIn()" class="font-size-16 shadow-text-none">
                                {{
                                    translate('playalone_share_quiz_modal_save_report_footer', {
                                        limit: limitPlayer,
                                        s: limitPlayer > 1 ? 's' : ''
                                    })
                                }}
                            </p>
                            <span
                                v-if="!isTeacherPlus"
                                @click="openPaymentPopup"
                                class="font-size-16 shadow-text-none underline cursor-pointer"
                            >
                                {{ translate('playalone_share_quiz_modal_save_report_footer_upgrade') }}
                            </span>
                        </div>
                    </template>

                    <template v-if="isFrontPage">
                        <p class="font-size-16 shadow-text-none">
                            {{ translate('playalone_share_quiz_modal_description') }}
                        </p>
                        <XInput
                            @focus.native="onFocus"
                            :value="urlShare"
                            :readonly="true"
                            class="url-input w-full mt-5 p-4"
                        />
                        <div class="share-quiz-box flex justify-between mt-3">
                            <ShareButton
                                v-if="isFrontPage && !embedQuiz"
                                :disabled="!readyToCopy"
                                :url="urlShare"
                                :title="quizTitle"
                                share-type="copy"
                                class="x-button font-opensans w-full shadow-text-none system-button-color system-button-text-color"
                                font-weight="400"
                                tag="button"
                            >
                                <i class="fas fa-paste"></i>
                                {{ translate('playalone_share_quiz_modal_button_copy') }}
                            </ShareButton>
                            <ShareButton
                                v-if="isCanShare"
                                :url="urlShare"
                                :title="quizTitle"
                                share-type="share"
                                class="x-button font-opensans w-full shadow-text-none system-button-color system-button-text-color"
                                font-weight="400"
                                tag="button"
                            >
                                <i class="fas fa-share-alt"></i>
                                {{ translate('playalone_share_quiz_modal_button_share') }}
                            </ShareButton>
                        </div>

                        <p class="font-size-16 mt-5 text-center shadow-text-none">
                            {{ translate('playalone_share_quiz_modal_description2') }}
                        </p>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import InnerLoader from '@/components/InnerLoader'
import XButton from '@/components/v2/XButton'
import XInput from '@/components/v2/XInput'
import XCheckbox from '@/components/v2/XCheckbox'
import { directive as onClickaway } from 'vue-clickaway'
import randomize from 'randomatic'
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import { getToken, isLoggedIn, currentUser } from '@/lib/user.js'
import helperMixins from '@/mixins/helper'
import Qrcanvas from 'qrcanvas-vue'
import ShareButton from '@/components/ShareButton'
import Selection from '@/components/v2/Selection'

export default {
    name: 'play-alone-share-modal',

    directives: {
        onClickaway: onClickaway
    },

    mixins: [helperMixins],

    components: {
        InnerLoader,
        XInput,
        XButton,
        XCheckbox,
        Qrcanvas,
        ShareButton,
        Selection
    },

    props: {
        value: {},

        quizId: {},

        isFrontPage: {
            type: Boolean,
            default: false
        },

        embedQuiz: {
            type: Boolean,
            default: false
        },

        title: {
            type: String,
            default: ''
        },

        subTitle: {
            type: String,
            default: ''
        },

        quizTitle: {
            type: String,
            default: ''
        }
    },

    computed: {
        readyToCopy() {
            if (!this.reportOpt) {
                return true
            }

            if (this.reportOpt == 'create_new' && !this.reportName) {
                return false
            }

            if (this.reportOpt == 'save_to_latest' && !this.reportId) {
                return false
            }

            return true
        },

        qrCodeOptions() {
            return {
                data: this.urlShare,
                cellSize: 6
            }
        },

        isCanShare() {
            return typeof window.navigator.canShare === 'function'
        },

        isTeacherPlus() {
            return currentUser().role.includes('teacher_plus')
        },

        isFeideUser() {
            return currentUser().provider === 'feide'
        },

        isUserInOsloSchool() {
            return this.currentSchool && this.currentSchool.is_oslo_school
        }
    },

    data() {
        return {
            isLoading: false,
            showReport: false,
            reportToken: '',
            reportName: '',
            reportId: '',
            reportOpt: '',
            createdReports: [],
            canOpenReportSetting: false,
            limitPlayer: 0,
            limitPlayerOriginal: 0,
            urlShare: '',
            isSelectReport: false,
            isSpecifyEmail: true,
            isForceLoginFeide: false,
            useWhiteList: false,
            whitelists: [],
            whitelistId: '',
            isSharedReport: false,
            isLocked: false
        }
    },

    watch: {
        showReport(val) {
            if (!val) {
                this.reportOpt = ''
                this.reportId = ''
                this.reportName = ''
                // this.onSelectReportOpt({target: {value: ''} })
            }
        }
    },

    mounted() {
        this.getPlayAloneList()
        this.urlShare = this.value

        if (isLoggedIn()) {
            this.findOrderAbility()
            this.getLimitPlayer()
            this.fetchWhitelist()
        }
    },

    methods: {
        isLoggedIn() {
            return isLoggedIn()
        },

        closeModal() {
            this.urlShare = ''

            if (!this.subTitle) {
                this.$emit('close')
            }
        },

        onFocus(e) {
            e.target.select()
        },

        generateReportUrlUrl(url, token, isGenerateToken, isSharedReport = false) {
            url = new URL(url)

            if (isSharedReport) {
                const user = currentUser().id
                token = 'shared-' + btoa(`${token}.${user}`)
            }

            url.searchParams.set('rp', token)

            if (!isGenerateToken) {
                url.searchParams.delete('rp')
            }

            return url.toString()
        },

        generateToken() {
            return randomize('A0', 17)
        },

        onSelectReportOpt(e) {
            const token = this.generateToken()
            const url = this.generateReportUrlUrl(this.value, token, e.target.value === 'create_new')

            this.reportOpt = e.target.value

            if (this.reportOpt === 'create_new') {
                this.getLimitPlayer()
            }

            this.reportToken = token

            this.reportId = ''

            this.$emit('input', url)
        },

        createRequest() {
            const token = getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },

        onCopied() {
            this.$emit('copied', this.urlShare)
        },

        onShare() {
            this.$emit('share', this.urlShare)
        },

        onCreateReport() {
            const request = this.createRequest()
            this.isLoading = true

            const token = this.generateToken()

            return request
                .post(appConfig.api.newReport, {
                    quiz_id: this.quizId,
                    name: this.reportName,
                    id: this.reportId,
                    token: token
                })
                .then(res => {
                    this.reportId = res.data.data.id

                    const url = new URL(this.value)

                    if (url.searchParams.has('rp')) {
                        url.searchParams.set('rp', token)
                    } else {
                        url.searchParams.append('rp', token)
                    }

                    this.urlShare = url.toString()
                    this.qrCodeOptions.data = this.urlShare
                    this.isLoading = false
                    this.showReport = true
                    this.isSelectReport = false
                    this.isForceLoginFeide = false
                    this.getPlayAloneList()
                })
                .catch(() => {
                    this.isLoading = false
                })
                .finally(() => {
                    this.isLoading = false
                    this.reportOpt = ''
                })
        },

        onSelectReport(value) {
            this.reportId = value
            this.reportToken = ''
            this.isSelectReport = false
            let foundReport = this.createdReports.find(report => report._id.$oid === this.reportId)

            if (foundReport) {
                this.reportToken = foundReport.token
                this.limitPlayer = foundReport.limit_player || 0
                this.isSpecifyEmail =
                    typeof foundReport.is_specify_email != 'undefined' ? foundReport.is_specify_email : true
                this.isForceLoginFeide = foundReport.is_force_login_with_feide ? true : false
                this.useWhiteList = foundReport.use_school_white_list ? true : false
                this.whitelistId =
                    foundReport.school_white_list_id && foundReport.school_white_list_id.$oid
                        ? foundReport.school_white_list_id.$oid
                        : ''

                this.isSharedReport = foundReport.is_shared_report
                this.isLocked = foundReport.is_locked ? true : false
            } else {
                this.limitPlayer = this.limitPlayerOriginal
            }

            const url = this.generateReportUrlUrl(this.value, this.reportToken, true, foundReport.is_shared_report)

            this.urlShare = url
            this.qrCodeOptions.data = url

            this.$emit('input', url)
        },

        getPlayAloneList() {
            if (!this.isLoggedIn()) {
                return
            }

            const request = this.createRequest()

            const getPlatAloneList = () => {
                const url = appConfig.api.playaloneReportList.replace('__id__', this.quizId)

                return new Promise((resolve, reject) => {
                    request
                        .get(url)
                        .then(res => resolve(res.data.data))
                        .catch(err => reject(err))
                })
            }

            const getSharedList = () => {
                const url = appConfig.api.sharedReportList.replace('__id__', this.quizId)

                return new Promise((resolve, reject) => {
                    request
                        .get(url)
                        .then(res => resolve(res.data.data))
                        .catch(err => reject(err))
                })
            }

            Promise.all([getSharedList(), getPlatAloneList()]).then(res => {
                const sharedReports = res[0].map(report => {
                    return {
                        ...report,
                        is_shared_report: true,
                        custom_report_id: `shared_${report._id.$oid}`
                    }
                })

                const myReports = res[1].map(report => {
                    return {
                        ...report,
                        is_shared_report: false,
                        custom_report_id: `my_${report._id.$oid}`
                    }
                })

                this.createdReports = []

                if (sharedReports.length) {
                    this.createdReports.push({
                        _id: {
                            $oid: ''
                        },
                        name: `► ${this.$t('report_option_divider_shared_report')}`,
                        limit_player: 0,
                        disabled: 0
                    })

                    this.createdReports.push(...sharedReports)
                }

                if (myReports.length) {
                    // If there are only my report, dont need to show divider
                    if (sharedReports.length) {
                        this.createdReports.push({
                            _id: {
                                $oid: ''
                            },
                            name: `► ${this.$t('report_option_divider_my_report')}`,
                            limit_player: 0,
                            disabled: 0
                        })
                    }

                    this.createdReports.push(...myReports)
                }
            })
        },

        async onToggleReportSetting() {
            this.isSharedReport = false
            this.isLocked = false

            if (this.showReport && this.isSelectReport) {
                this.reportOpt = ''
                this.isSelectReport = false
                return (this.showReport = false)
            }

            if (this.canOpenReportSetting === true && !this.showReport) {
                this.reportOpt = 'create_new'
                this.reportId = ''
                this.showReport = false
                this.isSelectReport = !this.isSelectReport
                return (this.showReport = true)
            }

            this.isLoading = true

            const ability = await this.findOrderAbility()

            this.whitelistId = ''
            this.useWhiteList = false

            if (!ability.is_24hrs_access && !ability.has_subscribed) {
                this.isLoading = false
                this.$emit('close')
                return this.$emit('open-payment-popup', 'report')
            }

            if (ability.is_24hrs_access || ability.has_subscribed) {
                this.canOpenReportSetting = true
            }

            if (!this.showReport && !this.isSelectReport) {
                this.reportOpt = 'create_new'
                this.isSelectReport = true
                this.showReport = false
                this.reportId = ''
                this.isLoading = false

                return
            } else if (this.showReport && !this.isSelectReport) {
                this.reportOpt = 'create_new'
                this.isSelectReport = true
                this.showReport = true
                this.isLoading = false
                this.reportId = ''

                return
            }

            this.isSelectReport = false
            this.showReport = true
            this.isLoading = false
        },

        findOrderAbility() {
            const request = this.createRequest()

            return new Promise((resolve, reject) => {
                request
                    .get(appConfig.api.findOrderAbility)
                    .then(res => resolve(res.data.data))
                    .catch(err => reject(err))
            })
        },

        openPaymentPopup() {
            this.$emit('open-payment-popup', 'report')
        },

        async getLimitPlayer() {
            const request = this.createRequest()
            let limit = await request.get(appConfig.api.limitPlayer)
            if (limit.status === 200) {
                this.limitPlayer = limit.data.data.limit
                this.limitPlayerOriginal = limit.data.data.limit
            }
        },

        handleToggleMail() {
            this.isSpecifyEmail = !this.isSpecifyEmail
            this.isLoading = true

            const request = this.createRequest()
            const url = appConfig.api.newIdentifyEmail.replace('__id__', this.reportId)

            request
                .post(url, {
                    id: this.reportId,
                    is_specify_email: this.isSpecifyEmail
                })
                .finally(() => {
                    this.isLoading = false
                    this.getPlayAloneList()
                })
        },

        handleToggleForceLoginFeide() {
            this.isForceLoginFeide = !this.isForceLoginFeide
            this.isLoading = true

            const request = this.createRequest()
            let url = appConfig.api.forceLoginWithFeide.replace('__id__', this.reportId)

            // If force login with feide is enabled, whitelist should be disabled
            if (this.isForceLoginFeide && this.useWhiteList) {
                this.useWhiteList = false
                this.updateUseWhitelist()
            }

            request
                .post(url, {
                    id: this.reportId,
                    is_force_login_with_feide: this.isForceLoginFeide
                })
                .finally(() => {
                    this.isLoading = false
                    this.getPlayAloneList()
                })
        },

        async fetchWhitelist() {
            // Only school roles can use whitelist
            if (!this.isSchoolRoles) {
                return
            }

            this.isLoading = true

            try {
                this.whitelists = await this.$store.dispatch('getSchoolWhitelistAll')
            } finally {
                this.isLoading = false
            }
        },

        async handleToggleUseWhiteList() {
            this.useWhiteList = !this.useWhiteList

            // Toggle if use whitelist, then force login with feide should be disabled
            if (this.useWhiteList && this.isForceLoginFeide && this.isFeideUser) {
                this.handleToggleForceLoginFeide()
            }

            this.updateUseWhitelist()
        },

        updateUseWhitelist() {
            const request = this.createRequest()
            let url = appConfig.api.updateWhitelistToReport.replace('__id__', this.reportId)

            this.isLoading = true

            request
                .post(url, {
                    id: this.reportId,
                    use_school_white_list: this.useWhiteList,
                    school_white_list_id: this.whitelistId
                })
                .then(() => {
                    this.getPlayAloneList()
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variable.scss';
@import '@/scss/mixin.scss';

.share-modal {
    font-family: 'Open Sans', sans-serif !important;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: start;
    font-size: 1.2em;
    z-index: 9999;

    .modal-backdrop {
        z-index: 1;
    }

    .modal-content {
        background-color: #fff;
        margin-top: 4rem;
        min-height: 483px;
        max-height: calc(100% - 6rem);
        width: 500px !important;
        overflow: hidden;
        border-radius: 3px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);
        z-index: 2;

        @include screen-max-md {
            max-height: calc(100% - 2rem);
            margin: 1rem 0.5rem;
        }

        .input {
            font-weight: bold;
            padding: 0.4rem;
        }

        .modal-body {
            overflow-y: auto;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                width: 0px;
            }

            .create-report-box {
                column-gap: 1rem;
            }

            .btn-create-report {
                height: auto;
            }

            .url-input {
                height: 45px;
                font-size: 1rem;
                font-weight: 400;
                border: 1px solid $input-border-color;
            }

            .share-quiz-box {
                column-gap: 2rem;
                row-gap: 0.5rem;

                @media screen and (max-width: 767px) {
                    flex-direction: column;
                }

                button {
                    height: 45px;
                }
            }

            .identify-box {
                column-gap: 1rem;
            }

            #report-select,
            .select-input {
                padding: 0.4rem;
                width: 100%;
                height: 45px;
                background-color: transparent;
                border: 1px solid $input-border-color;
                border-radius: 4px;
                font-weight: 400;

                option {
                    font-size: 16px;
                }

                @include screen-max-md {
                    font-size: 16px;
                }
            }

            .qrcode {
                max-height: 10rem;
                aspect-ratio: 1 / 1;
            }

            .social-navigation-box {
                column-gap: 16px;
            }

            .footer-box {
                line-height: 1.4;
            }

            .x-button {
                // min-width: 80px;
                height: 40px;
                padding: 0 16px;
                font-size: 16px;
                border: none;
                border-radius: 4px;
                color: #fff;
                background-color: #000;
                display: flex;
                justify-content: center;
                align-items: center;
                column-gap: 8px;
                cursor: pointer;
                transition: background-color 0.3s;

                &:hover {
                    background-color: rgba(#000, 0.7);
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed !important;
                }
            }
        }
    }
}
</style>
